<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="user-edit-tab-info">
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="flex items-start flex-col sm:flex-row">
          <vs-avatar :src="data_local.avatar" size="80px" class="mr-4" />
          <div>
            <p class="text-lg font-medium mb-2 mt-4 sm:mt-0">{{ data_local.first_name  }} {{ data_local.last_name}}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Content Row -->
    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full">
        <vs-input class="w-full mt-4" label="First Name" v-model="data_local.first_name"  name="firstname" />
       <!--  <span class="text-danger text-sm" v-show="errors.firstname">{{ errors.firstname }}</span> -->

        <!-- <span class="text-danger text-sm"  v-show="errors.has('firstname')">{{ errors.first('firstname') }}</span> -->
        <vs-input class="w-full mt-4" label="Last Name" v-model="data_local.last_name"  name="lastName" />
        <!-- <span class="text-danger text-sm"  v-show="errors.has('name')">{{ errors.first('name') }}</span> -->
        <vs-input class="w-full mt-4" label="Email" v-model="data_local.mail" type="email" name="email" />
        <!-- <span class="text-danger text-sm"  v-show="errors.has('email')">{{ errors.first('email') }}</span> -->
      </div>

      <div class="vx-col md:w-1/2 w-full">      
        <vs-input class="w-full mt-4" label="Phone" v-model="data_local.phone" name="phone" />
        <!-- <span class="text-danger text-sm"  v-show="errors.has('email')">{{ errors.first('email') }}</span> -->
        <vs-input class="w-full mt-4" label="Address" v-model="data_local.address" name="address" />
        <!-- <span class="text-danger text-sm"  v-show="errors.has('email')">{{ errors.first('email') }}</span> -->
        <div class="mt-4">
          <label class="vs-input--label">Country</label>
          <v-select v-model="status_local" :clearable="false" :options="countriesOptions" name="country" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
          <!-- <span class="text-danger text-sm"  v-show="errors.has('status')">{{ errors.first('status') }}</span> -->
        </div>
      </div>
    </div>

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="save_changes" :disabled="!validateForm">Save Changes</vs-button>
          <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Reset</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'

export default {
  components: {
    vSelect
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      data_local: JSON.parse(JSON.stringify(this.data)),
      countriesOptions: [],
      errors: {}
    }
  },
  mounted(){
    //console.log(this.status_local)
    this.loadCountriesOptions();
  },
  computed: {
    status_local: {
      get () {
        return { label: this.capitalize(this.data_local.country),  value: this.data_local.countryId  }
      },
      set (obj) {
        this.data_local.country = obj
      }
    },
    validateForm() {
      if (this.errors && Object.keys(this.errors).length > 0) {
        return false;
      }
      return true;
    },
    setErrors(fieldName, errorMessage) {
      this.errors[fieldName] = errorMessage;
    },
    // Método para borrar un error específico
    clearError(fieldName) {
      delete this.errors[fieldName];
    }
  },
  methods: {
    async loadCountriesOptions() {
      const { data } = await this.$http.get(`${process.env.apiRobocob}/api/getCountries`);
      //console.log(data)
      this.countriesOptions = data;
    },
    capitalize (str) {
      return str.slice(0, 1).toUpperCase() + str.slice(1, str.length)
    },
    save_changes () {
      /* eslint-disable */
      if (!this.validateForm) return

      // Here will go your API call for updating data
      // You can get data in "this.data_local"

      /* eslint-enable */
    },
    reset_data () {
      this.data_local = JSON.parse(JSON.stringify(this.data))
    },
    update_avatar () {
      // You can update avatar Here
      // For reference you can check dataList example
      // We haven't integrated it here, because data isn't saved in DB
    }
  }
}
</script>
